// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BgWI","content":"styles_content__3kp1z","row":"styles_row__39xfK","footer":"styles_footer__16OkE","phraseLength":"styles_phraseLength__1wQKb"};